// extracted by mini-css-extract-plugin
module.exports = {"breadcrumbs":"styles_breadcrumbs__34gqN","item":"styles_item__1Kp26"};